import * as React from 'react';

import Zoom from '@mui/material/Zoom';
import Stack from '@mui/material/Stack';
import {styled} from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const SuccessMessage: React.FC = () => {
    const Item = styled(Paper)(({theme}) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        margin: '30px',
        padding: '30px',
        textAlign: 'center',
        minWidth: '420px',
    }));

    return (
        <Zoom in={true}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <Item>
                    <CheckCircleRoundedIcon color="success" />
                    <h2>Signed successfully</h2>
                    Thank you for signing the order.
                    <br />
                    After completion of transportation, the <br />
                    original Order will be sent to you by email.
                </Item>
            </Stack>
        </Zoom>
    );
};

export default SuccessMessage;
